"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = exports.Separator = void 0;
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var _MAX_HEIGHT = 200;
var _MIN_WIDTH = 160;
exports.Separator = {
    element: react_1.default.createElement("div", { className: "border-t border-grey-lightest" }),
};
/**
 * TODO: We currently use onMouseDown rather than onMouseClick, because the blur event that happens
 * between the mouse down and the mouse up can trigger the dropdown closing if the click is very
 * slow (see GO-176). A better alternative would be to use a different approach than relying on the
 * toggle element's blur, for example using the react-onclickoutside library:
 * https://www.npmjs.com/package/react-onclickoutside
 *
 */
var Dropdown = /** @class */ (function (_super) {
    __extends(Dropdown, _super);
    function Dropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            open: false,
            highlightedEntry: 0,
            dropdownDimensions: {},
        };
        _this.maxHeight = _this.props.maxHeight || _MAX_HEIGHT;
        _this.portalEl = document.createElement("div");
        _this.toggleRef = react_1.default.createRef();
        _this.handleFocus = _this.handleFocus.bind(_this);
        _this.handleBlur = _this.handleBlur.bind(_this);
        _this.handleKeyDown = _this.handleKeyDown.bind(_this);
        _this.handleMouseDown = _this.handleMouseDown.bind(_this);
        return _this;
    }
    Dropdown.prototype.componentWillMount = function () {
        document.body.appendChild(this.portalEl);
    };
    Dropdown.prototype.componentWillUnmount = function () {
        document.body.removeChild(this.portalEl);
    };
    Dropdown.prototype.componentDidUpdate = function (_, prevState) {
        if (prevState.open != this.state.open) {
            // Get the toggle element dimensions, if the toggle ref has already been assigned
            // Note that, since we only need this when the dropdown is expanded, we are
            // fine if the first render call does not yet have the toggle ref defined
            var toggleDimensions = this.toggleRef.current !== null
                ? this.toggleRef.current.getBoundingClientRect()
                : null;
            // Ensure the dropdown appears under the toggle (top: toggle top + toggle
            // height) and that the dropdown has the same width as the toggle
            var dropdownDimensions = {};
            if (toggleDimensions) {
                dropdownDimensions = {
                    minWidth: _MIN_WIDTH,
                    maxHeight: this.maxHeight,
                };
                if (this.props.alignRight) {
                    // note we need to use the client's width because the bounding rect
                    // right value (pixels from the is not the same as the style's right value
                    dropdownDimensions.right =
                        document.body.clientWidth - toggleDimensions.right;
                }
                else {
                    dropdownDimensions.left = toggleDimensions.left;
                }
                if (this.props.alignTop) {
                    dropdownDimensions.bottom =
                        document.body.clientHeight -
                            toggleDimensions.top +
                            toggleDimensions.height;
                }
                else {
                    dropdownDimensions.top =
                        toggleDimensions.top + toggleDimensions.height;
                }
            }
            this.setState({ dropdownDimensions: dropdownDimensions });
        }
    };
    Dropdown.prototype.render = function () {
        var _this = this;
        var toggle = this.props.children({
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            onKeyDown: this.handleKeyDown,
            toggleRef: this.toggleRef,
        });
        var dropdown = react_dom_1.default.createPortal(this.state.open && this.props.items.length > 0 && (react_1.default.createElement("ul", { style: this.state.dropdownDimensions, className: "mt-2 fixed rounded border border-grey-lightest shadow-lg\nlist-reset bg-white z-50 overflow-y-auto" }, this.props.items.map(function (item, i) {
            return _this.props.renderFn ? (_this.props.renderFn(item, i)) : (react_1.default.createElement("li", { key: item.key === undefined ? i : item.key, onMouseDown: function (e) { return _this.handleMouseDown(e, item); }, className: "py-2 px-4 hover:bg-grey-lighter hover:text-black cursor-pointer\n".concat((_this.state.highlightedEntry === i && !_this.props.selectedValue) ||
                    (item.key === _this.props.selectedValue && "bg-blue-dark text-white")) }, item.element));
        }))), this.portalEl);
        var classes = ["Dropdown h-full relative"];
        if (this.props.className)
            classes.push(this.props.className);
        return (react_1.default.createElement("div", { className: classes.join(" ") },
            toggle,
            dropdown));
    };
    Dropdown.prototype.handleKeyDown = function (event) {
        if (event.key === "Escape") {
            this.blurToggleElement();
        }
        else if (event.key === "Enter") {
            this.selectItem(this.props.items[this.state.highlightedEntry]);
        }
        else {
            // Otherwise, if any key is hit and the toggle element has the focus, open the dropdown
            this.setState({ open: true });
            if (event.key === "ArrowUp") {
                this.setState({
                    highlightedEntry: (this.state.highlightedEntry + this.props.items.length - 1) %
                        this.props.items.length,
                });
            }
            else if (event.key === "ArrowDown") {
                this.setState({
                    highlightedEntry: (this.state.highlightedEntry + 1) % this.props.items.length,
                });
            }
        }
    };
    Dropdown.prototype.handleBlur = function () {
        var _this = this;
        setTimeout(function () { return _this.setState({ open: false }); }, 100);
    };
    Dropdown.prototype.handleFocus = function () {
        this.setState({ open: true });
    };
    Dropdown.prototype.handleMouseDown = function (e, item) {
        this.selectItem(item);
        e.preventDefault();
    };
    Dropdown.prototype.blurToggleElement = function () {
        if (this.toggleRef.current)
            this.toggleRef.current.blur();
    };
    Dropdown.prototype.selectItem = function (item) {
        if (this.props.onSelect) {
            this.props.onSelect(item);
        }
        this.blurToggleElement();
    };
    return Dropdown;
}(react_1.default.Component));
exports.Dropdown = Dropdown;
